import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const UserListScreen = lazy(() => import('../../screens/User/screens/List'));
const UserViewScreen = lazy(() => import('../../screens/User/screens/View'));

const userRoutes = [
    <Route
        exact
        key={routes.USER_LIST}
        path={routes.USER_LIST}
        render={() => (
            <Authenticated>
                <UserListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.USER_VIEW}
        path={routes.USER_VIEW}
        render={() => (
            <Authenticated redirectTo={routes.USER_LIST}>
                <UserViewScreen />
            </Authenticated>
        )}
    />,
];

export default userRoutes;
